<template>
  <div class="bg-canvas">
      <NuxtLayout>
          <template #body_page>
              <Banner :title="`Data Protection`"/>
              <div class='maxw-890 ma-0-auto pl-25 pr-25'>
                  <table class='mb-60 wp-100'>
                      <tr>
                          <td class="minw-192">
                              Designer Journeys
                          </td>
                          <td>
                              means Designer Journeys Pty Ltd, a private company trading as Designer Journeys.
                          </td>
                      </tr>
                      <tr>
                          <td>
                              GDPR
                          </td>
                          <td>
                              means the General Data Protection Regulation.
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Responsible Person
                          </td>
                          <td>
                              means Mr Matt McCann, Chief Executive Officer and Managing Director.
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Register of Systems
                          </td>
                          <td>
                              means a register of all systems or contexts in which personal data is processed by Designer Journeys.
                          </td>
                      </tr>
                  </table>
                  <ol>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>1. Data protection principles
                          </p>
                          <div class='mb-10'>
                              Designer Journeys is committed to processing data in accordance with its responsibilities under the GDPR.
                          </div>
                          <div class='mb-10'>
                              Article 5 of the GDPR requires that personal data shall be:
                          </div>
                          <ol>
                              <li>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              processed lawfully, fairly and in a transparent manner in relation to individuals;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>b.</span>
                                          <div>
                                              collected for specified, explicit and legitimate purposes and not further processed in a manner that is incompatible with those purposes; further processing for archiving purposes in the public interest, scientific or historical research purposes or statistical purposes shall not be considered to be incompatible with the initial purposes;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              adequate, relevant and limited to what is necessary in relation to the purposes for which they are processed;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>d.</span>
                                          <div>
                                              accurate and, where necessary, kept up to date; every reasonable step must be taken to ensure that personal data that are inaccurate, having regard to the purposes for which they are processed, are erased or rectified without delay;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>e.</span>
                                          <div>
                                              kept in a form which permits identification of data subjects for no longer than is necessary for the purposes for which the personal data are processed; personal data may be stored for longer periods insofar as the personal data will be processed solely for archiving purposes in the public interest, scientific or historical research purposes or statistical purposes subject to implementation of the appropriate technical and organisational measures required by the GDPR in order to safeguard the rights and freedoms of individuals; and
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>f.</span>
                                          <div>
                                              processed in a manner that ensures appropriate security of the personal data, including protection against unauthorised or unlawful processing and against accidental loss, destruction or damage, using appropriate technical or organisational measures.”
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>2. General provisions
                          </p>
                          <ol>
                              <li>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              This policy applies to all personal data processed by Designer Journeys.
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>b.</span>
                                          <div>
                                              The Responsible Person shall take responsibility for Designer Journeys’s ongoing compliance with this policy.
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              This policy shall be reviewed at least annually.
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>d.</span>
                                          <div>
                                              Designer Journeys shall register with the EU authorities as an organisation that processes personal data.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>3. Lawful, fair and transparent processing
                          </p>
                          <ol>
                              <li>
                                  <ol class='pl-10'>

                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              To ensure its processing of data is lawful, fair and transparent, Designer Journeys shall maintain a Register of Systems.
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      b.
                    </span>
                                          <div>
                                              The Register of Systems shall be reviewed at least annually.
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              Individuals have the right to access their personal data and any such requests made to Designer Journeys shall be dealt with in a timely manner.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>4. Lawful purposes
                          </p>
                          <ol>
                              <li>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              All data processed by Designer Journeys must be done on one of the following lawful bases: consent, contract, legal obligation, vital interests, public task or legitimate interests (<a href='https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/lawful-basis-for-processing/' target='_blank' rel="noreferrer noopener"><small class='fs-16 underline black'>see ICO guidance for more information</small></a>).
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>b.</span>
                                          <div>
                                              Designer Journeys shall note the appropriate lawful basis in the Register of Systems.
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              Where consent is relied upon as a lawful basis for processing data, evidence of opt-in consent shall be kept with the personal data.
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>d.</span>
                                          <div>
                                              Where communications are sent to individuals based on their consent, the option for the individual to revoke their consent should be clearly available and systems should be in place to ensure such revocation is reflected accurately in Designer Journeys’s systems.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>5. Data minimisation
                          </p>
                          <ol>
                              <li>
                                  <ol class='pl-10'>

                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              Designer Journeys shall ensure that personal data are adequate, relevant and limited to what is necessary in relation to the purposes for which they are processed.
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      b.
                    </span>
                                          <div>
                                              Designer Journeys collects web site data via cookies and names and email addresses for those people subscribing to our email service and who book trips via the site. We also collect email addresses and telephone numbers of people wanting custom Trip Plans
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>6. Accuracy
                          </p>
                          <ol>
                              <li>
                                  <ol class='pl-10'>

                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              Designer Journeys shall take reasonable steps to ensure personal data is accurate.
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      b.
                    </span>
                                          <div>
                                              Where necessary for the lawful basis on which data is processed, steps shall be put in place to ensure that personal data is kept up to date.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>7. Archiving / removal
                          </p>
                          <ol>
                              <li>
                                  <ol class='pl-10'>

                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              To ensure that personal data is kept for no longer than necessary, Designer Journeys shall put in place an archiving policy for each area in which personal data is processed and review this process annually.
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      b.
                    </span>
                                          <div>
                                              The archiving policy shall consider what data should/must be retained, for how long, and why.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>8. Security
                          </p>
                          <ol>
                              <li>
                                  <ol class='pl-10'>

                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              Designer Journeys shall ensure that personal data is stored securely using modern software that is kept-up-to-date.
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      b.
                    </span>
                                          <div>
                                              Access to personal data shall be limited to personnel who need access and appropriate security should be in place to avoid unauthorised sharing of information.
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      c.
                    </span>
                                          <div>
                                              When personal data is deleted this should be done safely such that the data is irrecoverable.
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      d.
                    </span>
                                          <div>
                                              Appropriate back-up and disaster recovery solutions shall be in place.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>9. Breach
                          </p>
                          <div>
                              In the event of a breach of security leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, personal data, Designer Journeys shall promptly assess the risk to people’s rights and freedoms and if appropriate report this breach to the ICO (<a href="https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/personal-data-breaches/" target="_blank" rel="noreferrer noopener"><small class='underline black fs-16'>more information on the ICO website</small></a>).
                          </div>
                      </li>
                  </ol>
              </div>
          </template>
      </NuxtLayout>
  </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
// import DefaultLayout from '../../components/globals/layout/DefaultLayout'
import Banner from '~/components/sections/SectionBannerTitle/BannerTitle'
// import { useHead } from '@vueuse/head'
import {onMounted/*, computed, ref*/ } from 'vue'
// import Metadata from '~/assets/meta_data.json'

export default {
  name: 'data-protection',
  components: {
    /*DefaultLayout,*/
    Banner
  },

  setup() {
    // const route = useRoute()
    // const runtime = useRuntimeConfig()
    // const metaData = ref(Metadata);
    // const canonical = runtime.public.publicDomain + route.path

    onMounted(() => {
      debounceAmplitudeScriptTracking("View Data Protection")
    })

    // useHead({
    //   title: computed(() => {
    //     const title = metaData.value.data_protection.title
    //     return title
    //   }),
    //
    //   meta: computed(() => {
    //     const title = metaData.value.data_protection.title
    //     const description = metaData.value.data_protection.description
    //     return [
    //       {
    //         name: `title`,
    //         content: title,
    //       },
    //       {
    //         name: `description`,
    //         content: description,
    //       }
    //     ]
    //   }),
    //   link: computed(() => {
    //     return [
    //       { rel: 'canonical', href: `${canonical}`}
    //     ]
    //   }),
    // })
  }
}
</script>
<style scoped lang="scss">
table {
  border-collapse: collapse;
}
tr td {
  border: 1px solid #000;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 12px;
}
ol {
  li {
    margin-top: 15px;
    span {
      font-family: $font-family-base;
      font-weight: 700;
      color: $link; // v2 — numbered-list markers to brand green (was off-brand light $blue-branding)
      margin-right: 12px;
      display: inline-block;
      font-size: 20px;
      line-height: 28px;
    }
    div {
      line-height: 24px;
      font-size: 16px;
    }
    .flex div {
      padding-top: 2px;
    }
  }
}
</style>
